// First-touch marketing attribution capture.
// Stores the very first landing page, referrer and UTM params in localStorage
// so we can attribute a member to their original acquisition source at signup.

const KEY = 'inasw_first_touch';

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

export function captureFirstTouch() {
  try {
    if (localStorage.getItem(KEY)) return; // already captured — keep the FIRST touch
    const params = new URLSearchParams(window.location.search);
    const data = {
      landing_page: window.location.pathname + window.location.search,
      referrer: document.referrer || '',
      captured_at: new Date().toISOString(),
    };
    UTM_KEYS.forEach((k) => {
      const v = params.get(k);
      if (v) data[k] = v;
    });
    localStorage.setItem(KEY, JSON.stringify(data));
  } catch (e) {
    // localStorage may be unavailable (private mode) — non-critical
  }
}

export function getFirstTouch() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : {};
  } catch (e) {
    return {};
  }
}
